module.exports = __webpack_public_path__ + "img/4362dcc.svg";